import type { RegionOption } from './regionAccessOptions';
import RegionAccessRow from './RegionAccessRow';

interface RegionAccessListProps {
  options: RegionOption[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  lockedIds: string[];
  single: boolean;
}

export default function RegionAccessList({
  options,
  selectedIds,
  onChange,
  lockedIds,
  single,
}: RegionAccessListProps) {
  const selected = new Set(selectedIds);
  const locked = new Set(lockedIds);

  function toggle(id: string) {
    if (selected.has(id)) onChange(selectedIds.filter((x) => x !== id));
    else onChange(single ? [id] : [...selectedIds, id]);
  }

  if (options.length === 0) {
    return <p className="px-2.5 py-2 text-xs text-stone-400">No regions available</p>;
  }
  return (
    <div className="flex flex-col gap-1">
      {options.map((o) => (
        <RegionAccessRow
          key={o.id}
          option={o}
          checked={selected.has(o.id)}
          locked={locked.has(o.id)}
          onToggle={toggle}
        />
      ))}
    </div>
  );
}
